import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'SERVICES', path: '/services' },
    { name: 'PROJECTS', path: '/projects' },
    { name: 'ABOUT', path: '/about' },
    { name: 'CONTACT', path: '/quote' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-neutral-charcoal shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="border-b-2 border-primary-red">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/99ea03b7b81b29f9585eff6929d08ea6/e991eb0ea9706773f7a1b9558763ac2b.png" 
                alt="Vantex Construction LLC" 
                className="h-12 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-semibold tracking-wider transition-colors whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'text-primary-red'
                      : 'text-white hover:text-primary-red'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* Phone & CTA */}
            <div className="hidden lg:flex items-center space-x-6">
              <a
                href="tel:+14692544779"
                className="flex items-center text-white hover:text-primary-red transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-fill text-primary-red text-xl mr-2"></i>
                <span className="text-lg font-bold">(469) 254-4779</span>
              </a>
              <Link
                to="/quote"
                className="bg-primary-red hover:bg-primary-red-dark text-white px-6 py-3 font-bold text-sm tracking-wide transition-colors whitespace-nowrap cursor-pointer"
              >
                GET A QUOTE
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-white text-2xl cursor-pointer"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-neutral-charcoal border-t border-neutral-dark-gray">
          <div className="px-6 py-4 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-sm font-semibold tracking-wider transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-red'
                    : 'text-white hover:text-primary-red'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="tel:+14692544779"
              className="flex items-center text-white hover:text-primary-red transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-fill text-primary-red text-xl mr-2"></i>
              <span className="text-lg font-bold">(469) 254-4779</span>
            </a>
            <Link
              to="/quote"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block bg-primary-red hover:bg-primary-red-dark text-white px-6 py-3 font-bold text-sm tracking-wide transition-colors text-center whitespace-nowrap cursor-pointer"
            >
              GET A QUOTE
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;